const getValuesFromKey = (outputs = [], key, maxValues = 5) => {
  if (!key) return [];
  const keys = key.split('.');
  const values = [];

  if (!Array.isArray(outputs) && typeof outputs === 'object') {
    // This handles cases when output is an object. This should never happen, but if we ever decide to allow not array outputs this will prevent a crash.
    let current = outputs;
    let found = true;
    for (const k of keys) {
      if (current === null || current === undefined || current[k] === undefined) {
        found = false;
        break;
      }
      current = current[k];
    }
    if (found) values.push(current);
    return values;
  }

  for (const obj of outputs) {
    if (values.length >= maxValues) break; // Limit to maxValues

    let current = obj;
    let found = true;
    for (const k of keys) {
      if (current === null || current === undefined || current[k] === undefined) {
        found = false;
        break;
      }
      current = current[k];
    }
    if (found) values.push(current);
  }

  return values;
};

export default getValuesFromKey;
